import { LOAD_APP_CONFIG } from '../actionTypes';

const loadAppConfig = payload => ({
  type: LOAD_APP_CONFIG,
  payload,
});

export default loadAppConfig;



// WEBPACK FOOTER //
// ./src/redux/actions/appConfig.js